import React from 'react'

const TasksAssignedScreen = () => {
  return (
    <div>TasksAssignedScreen</div>
  )
}

export default TasksAssignedScreen